import React, { Component } from "react";
import ParticlesBg from "particles-bg";
import Fade from "react-reveal";
import "./style.css";

class Header extends Component {
  render() {
    if (!this.props.data) return null;

    const project = this.props.data.project;
    const github = this.props.data.github;
    const name = this.props.data.name;
    const description = this.props.data.description;

    return (
      <div id="theme">
        <header id="home">
          <ParticlesBg type="cobweb" bg={true} color="#ffffff" />

          <nav id="nav-wrap">
            <a className="mobile-btn" href="#nav-wrap" title="Show navigation">
              Show navigation
            </a>
            <a className="mobile-btn" href="#home" title="Hide navigation">
              Hide navigation
            </a>

            <ul id="nav" className="nav">
              <li className="current">
                <h1
                  style={{
                    fontSize: "xx-large",
                    color: "yellow",
                    marginRight: "30rem",
                  }}
                  className="smoothscroll"
                  href="#home"
                >
                  EGREMENGED IMPACT
                </h1>
              </li>
              <li className="current">
                <a className="smoothscroll" href="#home">
                  Home
                </a>
              </li>

              <li>
                <a className="smoothscroll" href="#about">
                  About Us
                </a>
              </li>

              <li>
                <a className="smoothscroll" href="#resume">
                  Projects
                </a>
              </li>

              <li>
                <a className="smoothscroll" href="#gallery">
                  Gallery
                </a>
              </li>

              <li>
                <a className="smoothscroll" href="#contact">
                  Contact Us
                </a>
              </li>
            </ul>
          </nav>

          <div className="row banner">
            <div className="banner-text">
              <Fade bottom>
                <h1 className="responsive-headline" id="intro">
                  {name}
                </h1>
              </Fade>
              <Fade bottom duration={1200}>
                <h3 className="intro" id="introduction">
                  {description}.
                </h3>
              </Fade>
              <hr />
              <Fade bottom duration={2000}>
                <ul className="social">
                  <a href={project} className="button btn warning">
                    <i className="fa fa-book"></i>Register Now!
                  </a>
                  <a href={github} className="button btn warning">
                    <i className="fa fa-telegram"></i>About Us
                  </a>
                </ul>
              </Fade>
            </div>
          </div>

          <p className="scrolldown">
            <a className="smoothscroll" href="#about">
              <i className="icon-down-circle"></i>
            </a>
          </p>
        </header>
      </div>
    );
  }
}

export default Header;
